import { useEffect, useState } from "react";
import Fetch from "../services/Fetch";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { clearStudentAuthSession } from "../utils/authSession";

function AuthProvider({ children }) {
    const host = `${process.env.REACT_APP_LOCAL_HOST}`;
    const [wait, setWait] = useState(true);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    const refreshUser = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            setUser(null);
            return null;
        }
        const result = await Fetch(host + '/account/get-profile', 'GET', null);
        if (result.status === 200) {
            setUser(result.data.data);
            return result.data.data;
        }
        return null;
    };

    useEffect(() => {
        const init = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setUser(null);
                    return;
                }

                const profile = await refreshUser();
                if (!profile) {
                    clearStudentAuthSession();
                    setUser(null);
                    return;
                }

                if (profile.account_role !== 'student') {
                    clearStudentAuthSession();
                    setUser(null);
                    return;
                }

                if (!profile.verified_at && window.location.pathname !== '/verify') {
                    navigate('/verify');
                    return;
                }

                if (
                    profile.verified_at
                    && !profile.major?.id
                    && !['/onboarding', '/verify'].includes(window.location.pathname)
                ) {
                    navigate('/onboarding');
                }
            } catch (err) {
                console.error(err);
                setUser(null);
            } finally {
                setWait(false);
            }
        };
        init();
    }, [navigate]);

    return (
        <AuthContext.Provider value={{
            wait,
            user,
            isAuthenticated: !!user,
            setUser,
            refreshUser,
        }}>
            {!wait && children}
        </AuthContext.Provider>
    );
}

export default AuthProvider;
